import "@picocss/pico"

import React, { ReactNode, useMemo, useState } from "react"
import ReactDOM from "react-dom"
// import { Input, List, PageHeader, Switch, Table } from "antd"
import * as primeLib from "./lib/primeLib"
import { githubCornerHTML } from "./lib/githubCorner"
import { repository, version } from "../package.json"

function main() {
    let div = document.createElement("div")
    div.innerHTML = githubCornerHTML(repository.url, version)
    document.body.appendChild(div)

    let appRoot = document.getElementById("appRoot")!
    ReactDOM.render(React.createElement(UserInterface), appRoot)
}

function UserInterface() {
    let [target, setTarget] = useState(2n)
    let [showTitles, setShowTitles] = useState(false)
    let [badInput, setBadInput] = useState("")

    let primeObject = useMemo(() => {
        return primeLib.getPrimeExponentObject(target)
    }, [target])

    let repetitionList = [] as string[]
    let powerResultList = [] as string[]
    let representationList = [] as string[]
    let exponentHtmlList = [] as ReactNode[]
    let exponentUnicodeList = [] as ReactNode[]

    Object.entries(primeObject).map(([prime, exponent]) => {
        repetitionList.push(...Array(Number(exponent)).fill(prime))
        powerResultList.push(`${(+prime) ** exponent}`)
        if (exponent > 1) {
            representationList.push(`${prime}**${exponent}`)
            exponentHtmlList.push(
                <span key={prime}>
                    {prime}
                    <sup>{exponent}</sup>{" "}
                </span>,
            )
            exponentUnicodeList.push(
                <span key={prime}>
                    {prime}
                    {unicodeSup(exponent)}{" "}
                </span>,
            )
        } else {
            representationList.push(String(prime))
            exponentHtmlList.push(<span key={prime}>{prime} </span>)
            exponentUnicodeList.push(<span key={prime}>{prime} </span>)
        }
    })
    if (target <= -2) {
        repetitionList[0] = "-" + repetitionList[0]
        representationList[0] = "-" + representationList[0]
        exponentHtmlList.unshift(<span key={"-"}>{"-"}</span>)
        exponentUnicodeList.unshift(<span key={"-"}>{"-"}</span>)
        powerResultList[0] = "-" + powerResultList[0]
    } else if (target < 2) {
        repetitionList.push(`${target}`)
        representationList.push(`${target}`)
        exponentHtmlList.push(<span key={"" + target}>{"" + target}</span>)
        exponentUnicodeList.push(<span key={"" + target}>{"" + target}</span>)
        powerResultList.push(`${target}`)
    }

    return (
        <>
            <input
                defaultValue={2}
                type="text"
                onChange={(event) => {
                    let v = event.target.value

                    if (v.length <= 18) {
                        try {
                            setTarget(BigInt(v))
                            setBadInput("")
                        } catch {
                            setBadInput("Invalid number")
                        }
                    } else {
                        setBadInput("The input number cannot be longer than 18 digits")
                    }
                }}
                style={{ width: "300px" }}
            />
            <div>
                <input
                    id="showTitles"
                    type="checkbox"
                    checked={showTitles}
                    onChange={() => {
                        setShowTitles(!showTitles)
                    }}
                />
                <label htmlFor="showTitles" style={{ fontSize: "small", margin: "10px" }}>
                    Show Line Titles
                </label>
            </div>

            {badInput ? (
                <em>
                    <br />
                    {badInput}
                </em>
            ) : null}

            <table>
                <tbody>
                    {[
                        { title: "Repeating prime", value: repetitionList.join(" * ") },
                        {
                            title: "Power result",
                            value: powerResultList.join(" * "),
                        },
                        {
                            title: "Prime and exponent (**)",
                            value: representationList.join(" * "),
                        },
                        {
                            title: "Prime and exponent (HTML)",
                            value: exponentHtmlList,
                        },
                        {
                            title: "Prime and exponent (Unicode)",
                            value: exponentUnicodeList,
                        },
                    ].map(({ title, value }) => {
                        let titleElement = showTitles ? <th>{title}</th> : null
                        return (
                            <tr key={title}>
                                {titleElement}
                                <td>{value}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

function unicodeSup(exponent: number) {
    return [...String(Math.floor(exponent))]
        .map((digit) => {
            if (digit === "-") {
                return "⁻"
            }
            return "⁰¹²³⁴⁵⁶⁷⁸⁹"[Number(digit)]
        })
        .join("")
}

main()
